import { Link, Navigate } from "react-router-dom";
import moment from "jalali-moment";
import { Fade } from "react-awesome-reveal";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import biorhythmChart from "../../assets/images/biorhythm-chart.png";
import subordinateUsers from "../../assets/images/subordinate-users.png";
import checkupHistory from "../../assets/images/checkup-history.png";
import UploadedTests from "../../assets/images/uploaded-tests.png";
import PetsImage from "../../assets/images/home-pets.png";
import SmartPhoneImage from "../../assets/images/smart-phone.png";
import SmartWatchImage from "../../assets/images/smart-watch.png";
import DNAViewer from "../../components/homepage/dnaViewer";
import HeroTests from "../../components/homepage/heroTests";
import Physical from "../../components/homepage/physical";
import LastTestData from "../../components/homepage/lastTestData";
import useStore from "../../features/store";

const Home = () => {
  const has_token = localStorage.getItem("refresh_token");
  //@ts-ignore
  const { profile } = useStore();

  if (!has_token) {
    return <Navigate to="/intro" />;
  }
  return (
    <div className="flex-1 mt-5">
      <Fade triggerOnce>
        <HeroTests />

        {!profile?.has_password && (
          <Link
            to="/profile/password"
            className="flex flex-row justify-between items-center bg-pr_red p-5 rounded-xl mt-2 lg:mt-5"
          >
            <span className="flex-[3] font-rokh font-[700] pt-[5px] ">
              اگه برای پروفایلت رمز عبور انتخاب کنی، راحت‌تر می‌تونی وارد شی!
            </span>
            <div className="flex-1 flex justify-end">
              <div className="w-7 h-7 rounded-full bg-pr_red_dark text-white p-1 flex items-center justify-center">
                <HiOutlineArrowLongLeft size={25} />
              </div>
            </div>
          </Link>
        )}

        <div className="flex flex-col lg:flex-row gap-2 lg:gap-5 mt-2 lg:mt-5">
          <Physical
            weight={profile?.additional_details?.weight}
            height={profile?.additional_details?.height}
            bmi={profile?.additional_details?.bmi}
          />
          <div className="flex-1 flex flex-col gap-2 lg:gap-5">
            <Link
              to="/biorhythm"
              className="flex-1 bg-pr_yellow relative rounded-xl overflow-hidden px-5 py-10 lg:p-8"
            >
              <img
                src={biorhythmChart}
                className="absolute -left-3 lg:-left-3 -bottom-12 lg:-bottom-16 h-[200px] lg:h-[280px]"
              />
              <h2 className="font-rokh font-[900] text-xl">
                بیا بهت بگم <br />
                امروز حالت چطوریه!
              </h2>
              <p className="text-sm font-rokh font-[700]">
                منحنی بایوریتم بادی‌بان
              </p>
              <HiOutlineArrowLongLeft size={30} className="mt-5" />
            </Link>

            <div className="flex flex-row items-center justify-between gap-2 lg:gap-5">
              <Link
                to="/records"
                className="flex-[1] bg-pr_blue relative rounded-xl overflow-hidden px-5 py-8 lg:p-8"
              >
                <img
                  src={checkupHistory}
                  className="absolute left-1 lg:left-0 -bottom-3 lg:-bottom-6 h-[100px] lg:h-[150px]"
                />

                <h2 className="flex items-end font-rokh font-[900] text-lg lg:text-xl">
                  آزمایش‌های <br />
                  ثبت‌شده
                </h2>
                <div className="badge bg-white px-5 pt-4 pb-3 font-rokh font-[700] text-xs mt-2">
                  {profile?.test_count} مورد
                </div>
                <HiOutlineArrowLongLeft size={23} className="mt-6" />
              </Link>

              <Link
                to="/subcategory-users"
                className="flex-[1] bg-pr_purple relative rounded-xl overflow-hidden px-5 py-8 lg:p-8"
              >
                <img
                  src={subordinateUsers}
                  className="absolute -left-2 lg:-left-4 -bottom-4 lg:-bottom-8 h-[110px] lg:h-[160px]"
                />

                <h2 className="flex items-end font-rokh font-[900] text-lg lg:text-xl">
                  کاربران <br />
                  زیرمجموعه
                </h2>
                <div className="badge bg-white px-5 pt-4 pb-3 font-rokh font-[700] text-xs mt-2">
                  {profile?.temp_user_count} مورد
                </div>
                <HiOutlineArrowLongLeft size={23} className="mt-6" />
              </Link>
            </div>
          </div>
        </div>

        {profile?.general_score && profile?.latest_test_panels && (
          <LastTestData />
        )}

        <div className="flex flex-col lg:flex-row gap-2 lg:gap-5 my-2 lg:my-5">
          <div className="flex-[1] bg-pr_yellow relative rounded-xl overflow-hidden px-5 py-10 lg:p-8">
            <div>
              {profile?.latest_test_date && (
                <div className="badge bg-white px-3 py-3 font-[700] text-xs absolute left-[37%] bottom-16">
                  <div className="absolute left-[48%] -bottom-2 w-[3px] h-2 bg-white rounded-full"></div>
                  {(profile &&
                    moment
                      .from(profile.latest_test_date, "en", "YYYY-MM-DD")
                      .locale("fa")
                      .format("jDD/jMMMM/jYYYY")) ??
                    ""}
                </div>
              )}
              <img
                src={UploadedTests}
                className="absolute left-0 bottom-2 w-full h-auto"
              />
            </div>
            <div className="mb-32">
              <h2 className="font-rokh font-[900] text-xl">آخرین آزمایشت</h2>
              {profile?.time_since_latest_test ? (
                <p className="text-sm font-rokh font-[700]">
                  از آخرین آزمایشت
                  <strong className="text-sm font-rokh font-[900]">
                    {" "}
                    {(profile && profile?.time_since_latest_test) ?? ""}
                  </strong>{" "}
                  روز گذشته
                </p>
              ) : (
                <p className="text-sm font-rokh font-[700]">
                  توصیه می‌شه که هر شش ماه یه آزمایش خون برای چک‌آپ بدی.
                </p>
              )}
            </div>
          </div>

          <div className="flex-[1] relative bg-pr_green rounded-xl overflow-hidden px-5 py-10 lg:p-8">
            <img
              src={PetsImage}
              className="absolute left-2 lg:left-0 bottom-1 h-[150px] lg:h-[180px]"
            />
            <h2 className="font-rokh font-[900] text-xl">
              از حال حیوون خونگیت <br />
              خبر داری؟
            </h2>
            <p className="text-sm font-rokh font-[700]">
              تحلیل آزمایش حیوانات خانگی
            </p>

            <div className="badge bg-white border-none text-xs font-rokh font-[700] pt-4 pb-3 px-3 mt-10">
              به‌زودی، در این مکان!
            </div>
          </div>

          <div className="flex-[1] relative bg-pr_blue rounded-xl h-[250px] overflow-hidden px-5 py-10 lg:p-8">
            <h2 className="font-rokh font-[900] text-xl">
              با عکس آزمایشت <br /> صحبت کن!
            </h2>
            <p className="text-sm font-rokh font-[700]">تحلیل تصاویر پزشکی</p>

            <div className="badge bg-white border-none text-xs font-rokh font-[700] pt-4 pb-3 px-3 mt-10">
              به‌زودی، در این مکان!
            </div>

            <div className="absolute -top-44 left-52 w-full h-1/2 rotate-45">
              <DNAViewer />
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-2 lg:gap-5 my-2 lg:my-5">
          <div className="flex-[1] relative bg-pr_purple rounded-xl overflow-hidden px-5 py-10 lg:p-8 pb-20">
            <img
              src={SmartPhoneImage}
              className="absolute -left-5 -bottom-2 lg:-bottom-5 h-[170px] lg:h-[240px] scale-x-[-1]"
            />
            <h2 className="font-rokh font-[900] text-xl">
              دسترسی به <br /> برنامه سلامت گوشیت
            </h2>
            <p className="text-sm font-rokh font-[700] max-w-[250px] lg:max-w-xs">
              اگه اجازه بدی، می‌تونیم به اطلاعات خواب و فعالیت فیزیکیت دسترسی
              داشته باشیم و بیشتر بهت کمک کنیم.
            </p>

            <div className="badge bg-white border-none text-xs font-rokh font-[700] pt-4 pb-3 px-3 mt-10">
              به‌زودی، در این مکان!
            </div>
          </div>

          <div className="flex-[1] relative bg-pr_blue rounded-xl overflow-hidden px-5 py-10 lg:p-8 pb-20">
            <img
              src={SmartWatchImage}
              className="absolute -left-5 -bottom-2 lg:-bottom-5 h-[170px] lg:h-[240px]"
            />
            <h2 className="font-rokh font-[900] text-xl">
              ساعت هوشمند <br />
              داری؟!
            </h2>
            <p className="text-sm font-rokh font-[700] max-w-[250px] lg:max-w-xs">
              ساعت هوشمندت رو وصل کن به بادی‌بان و امتیاز سلامتیت رو چندین پله
              بالاتر ببر!
            </p>

            <div className="badge bg-white border-none text-xs font-rokh font-[700] pt-4 pb-3 px-3 mt-10">
              به‌زودی، در این مکان!
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default Home;
